import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-invoice',
  templateUrl: './student-invoice.component.html',
  styleUrls: ['./student-invoice.component.css']
})
export class StudentInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
